import { Button, Image } from "react-bootstrap";
import { DropdownImage } from "./customDropdownStyle";
import Donation_love_img from "../../../assests/images/header-dropdown-image/donation-love.svg";
import { MESSAGE } from "../../../utils/message";
//import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";


const DonateNow = () => {
    // const navigate = useNavigate();
    const availableModules = useSelector((state: any) => state?.modules?.data?.results);

    return (
        <DropdownImage>
            <Image src={Donation_love_img} alt="Donate love" width="168px" height="168px" />
            {availableModules?.donation && <Button onClick={() => window.location.href = "/org/greatnonprofits"} className="donate-now-btn">{MESSAGE.donateNowBtn}</Button>}
        </DropdownImage>
    )
};
export default DonateNow; 